;$(function() {
	function changeHeaderPosition() {
		var container = $('.header'),
			fixedHeader = $('.header__top');

		if ($(this).scrollTop() > 0) {
			fixedHeader.addClass('header__top_fixed');
			fixedHeader.addClass('shadow');
			container.css('padding-top', fixedHeader.outerHeight());
		} else {
			fixedHeader.removeClass('header__top_fixed');
			fixedHeader.removeClass('shadow');
			container.css('padding-top', '');
		}
	}

	$(window).resize(changeHeaderPosition);

	$(window).scroll(changeHeaderPosition);  
});